import { ISurveyConfirm } from "@common/models/SurveyConfirm";

export enum ParticipateAction {
    Participate
}

export interface IParticipateAction {
    type: ParticipateAction;
    payload: Partial<ISurveyConfirm>;
}